import React from 'react';
import standalonestyles from './standalone.module.css';

function SelectionCard({ activeButton, onClick, title }) {
    const renderIcon = () => {
        if (title === 'venues') {
            return (
                <svg
                    viewBox="0 0 64 64"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={standalonestyles['icon-style']}
                >
                    {/* Roof */}
                    <path d="M8 28 L32 8 L56 28" />
                    {/* Walls */}
                    <path d="M12 28 V56 H52 V28" />
                    {/* Door / Gate */}
                    <path d="M24 40 H40 V56 H24 Z" />
                    {/* Vertical lines on the door */}
                    <path d="M28 40 V56" />
                    <path d="M32 40 V56" />
                    <path d="M36 40 V56" />
                    {/* Hanger circle / keyhole on roof */}
                    <circle cx="32" cy="21" r="3.5" />
                    <path d="M32 17.5 V14.5" />
                </svg>
            );
        } else {
            return (
                <svg
                    viewBox="0 0 64 64"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={standalonestyles['icon-style']}
                >
                    {/* Left User Head */}
                    <circle cx="22" cy="20" r="5.5" />
                    {/* Left User Body */}
                    <path d="M10 38 C10 30 16 30 22 30 C28 30 34 30 34 38" />
                    {/* Right User Head */}
                    <circle cx="42" cy="20" r="5.5" />
                    {/* Right User Body */}
                    <path d="M30 38 C30 30 36 30 42 30 C48 30 54 30 54 38" />
                    {/* Badge Card in front */}
                    <rect x="20" y="38" width="24" height="16" rx="2" fill="none" />
                    {/* Badge photo square */}
                    <rect x="23" y="42" width="5" height="5" rx="0.5" />
                    {/* Badge lines */}
                    <line x1="31" y1="43" x2="40" y2="43" />
                    <line x1="31" y1="47" x2="37" y2="47" />
                </svg>
            );
        }
    };

    return (
        <div
            className={`${standalonestyles['Container']} ${activeButton ? standalonestyles['selected'] : ''}`}
            onClick={onClick}
        >
            {activeButton && (
                <div className={standalonestyles['iconstyle']}>
                    <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </div>
            )}
            
            <div className={standalonestyles['icon-container']}>
                {renderIcon()}
            </div>
            
            <span className={standalonestyles['card-text']}>{title}</span>
        </div>
    );
}

export default SelectionCard;